import $ from 'jquery';

const defaults = {
  sourceSelector: '.field-image.c1 img',
  destSelector: undefined,
  isPseudo: false,
};

function BackgroundImage(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.addBackgroundImage();
  this.ready();
}

BackgroundImage.prototype = {
  getSource() { return this.$element.find(this.settings.sourceSelector).attr('src'); },

  addBackgroundImage() {
    const src = this.getSource();
    if (src && src.length) {
      if (this.settings.isPseudo) {
        this.$element.find('.node').prepend('<span class="pod-image-bg"></span>');
        this.$element.find('.pod-image-bg').css('background-image', `url(${src})`);
      } else if (this.settings.destSelector) {
        this.$element.find(this.settings.destSelector).css('background-image', `url(${src})`);
      } else {
        this.$element.css('background-image', `url(${src})`);
      }
      this.$element.addClass('hasImage');
    }
  },

  ready() {
    setTimeout(() => {
      this.$element.addClass('ready');
    }, 300);
  },
};

export default BackgroundImage;
